import { useState } from 'react';
import Card from '../ui/Card';
import { WorkspaceShell } from '../ui/Workspace';
import { useAuth } from '../../contexts/AuthContext';
import AcademySettings from './AcademySettings';
import BranchesSettings from './BranchesSettings';
import DocumentationSettings from './DocumentationSettings';
import PaymentMethodsSettings from './PaymentMethodsSettings';

const TABS = [
  {
    id: 'academy',
    label: 'Academy',
    description: 'Name, branding, registration numbers and contact info.',
  },
  {
    id: 'branches',
    label: 'Branches',
    description: 'Manage physical locations used across courses and batches.',
  },
  {
    id: 'payments',
    label: 'Payment methods',
    description: 'Bank accounts, cash options and hosted checkout links.',
  },
  {
    id: 'documentation',
    label: 'Documentation',
    description: 'Generate, print, issue, sign, and verify institutional staff letters.',
  },
];

const SettingsPage = () => {
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState('academy');

  if (!currentUser || currentUser.role !== 'admin') {
    return (
      <WorkspaceShell
        title="Settings"
        description="Only administrators can manage academy settings."
      >
        <Card className="shadow-sm">
          <p className="text-sm text-gray-500">
            You need admin access to view this page.
          </p>
        </Card>
      </WorkspaceShell>
    );
  }

  const activeMeta = TABS.find((tab) => tab.id === activeTab) || TABS[0];

  return (
    <WorkspaceShell
      title="Settings"
      description="Configure how Brissbella Academy appears and operates across the LMS."
    >
      <div className="flex flex-wrap gap-2 border-b border-stone-200 pb-2">
        {TABS.map((tab) => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={`inline-flex items-center rounded-full px-4 py-2 text-sm font-semibold transition ${
                isActive
                  ? 'bg-pink-600 text-white shadow-sm'
                  : 'bg-white text-stone-600 ring-1 ring-stone-200 hover:bg-stone-50'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      <p className="text-sm text-stone-500">{activeMeta.description}</p>

      {activeTab === 'academy' ? <AcademySettings /> : null}
      {activeTab === 'branches' ? <BranchesSettings /> : null}
      {activeTab === 'payments' ? <PaymentMethodsSettings /> : null}
      {activeTab === 'documentation' ? <DocumentationSettings /> : null}
    </WorkspaceShell>
  );
};

export default SettingsPage;
